// Entry point for the build script
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo

import "./controllers"
import "./lib/lazy_chart" // Auto-loads chartkick when charts are detected
import "./missing_translations_logger"

